import {debounceTime, distinctUntilChanged, finalize, switchMap} from 'rxjs/operators';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Subject} from "rxjs";
import {CompanyDetailsService} from "../_services/company-details.service";
import {BankDetails} from "../_models/bank-detail";
import {HttpErrorResponse} from "@angular/common/http";
import {CompanyDetails} from "../_models/company-details";

@Component({
  selector: 'bank-search-field',
  templateUrl: './bank-search-field.component.html',
  styleUrls: ['./bank-search-field.component.css']
})
export class BankSearchFieldComponent implements OnInit {
  @Input() inputClass = 'form-control';
  @Input() placeholder = 'Поиск банка';
  @Output() onSelect = new EventEmitter<BankDetails>();
  @Output() onAutocompleteActive = new EventEmitter<boolean>();

  selected: BankDetails;
  bankDetails: BankDetails[] = [];
  searchBankValue: BankDetails|string = '';
  isSearching = false;

  private bankDetailsStream = new Subject<string>();
  private deactivateAutocompleteTimer: any;

  constructor(private companyDetailsService: CompanyDetailsService) { }

  ngOnInit() {
    this.initBankDetailsStream();
  }

  private initBankDetailsStream(): void {
    this.bankDetailsStream = new Subject();
    this.bankDetailsStream
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap(search => {
          this.isSearching = true;
          return this.companyDetailsService
            .getBankDetails(search)
            .pipe(finalize(() => this.isSearching = false))
            ;
        })
      )
      .subscribe({
        next: details => this.bankDetails = details,
        error: e => {
          if(e instanceof HttpErrorResponse && e.status == 404) {
            this.bankDetails = [];
          } else {
            console.error(e);
          }
          this.initBankDetailsStream();
        }
      })
    ;
  }

  customFilter(items: CompanyDetails[], query: string): CompanyDetails[] {
    return items;
  }

  onSelectCompanyDetails(details: CompanyDetails): void {
    this.onSelect.emit(details);
  }

  onChangeCompanySearch(value: CompanyDetails | string): void {
    if(typeof value != 'string')
      return;

    if(value == '') {
      this.searchBankValue = new CompanyDetails();
      this.bankDetails = [];
    } else {
      this.bankDetailsStream.next(value);
    }
  }

  onOpenAutocomplete(): void {
    console.log('autocomplete opened');
    this.onAutocompleteActive.next(true);
  }

  onCloseAutocomplete(): void {
    console.log('autocomplete closed');

    // здесь происходит странное, т.к. компонент для автокомплита не всегда вызывает событие открытия панели
    this.onAutocompleteActive.emit(true);

    if(this.deactivateAutocompleteTimer)
      clearTimeout(this.deactivateAutocompleteTimer);

    this.deactivateAutocompleteTimer = setTimeout(() => {
      console.log('autocomplete deactivated');
      this.onAutocompleteActive.emit(false);
      this.deactivateAutocompleteTimer = null;
    }, 1000);
  }
}
